import { createContext } from 'react';

export type Role = 'EMPLOYEE' | 'MANAGER' | 'HR_ADMIN' | 'SUPER_ADMIN';

/**
 * Feature flags que decide el backend (variable de entorno) y el frontend
 * usa para ocultar rutas/menús. Opcional por robustez: si un backend
 * antiguo no lo envía, los consumidores tratan la ausencia como habilitado
 * (`?? true`) — el comportamiento histórico.
 */
export interface AuthFeatures {
  documents: boolean;
}

export interface AuthUser {
  id: string;
  email: string;
  fullName: string;
  role: Role;
  companyId: string;
  mfaEnabled: boolean;
  passwordChangeRequired: boolean;
  privacyPolicyAcceptedAt: string | null;
  /** Última versión del panel de novedades vista por el usuario; null = ninguna. */
  whatsNewVersionSeen: string | null;
  /** Color de fondo del avatar (hex de paleta) o null = por defecto. */
  profileColor: string | null;
  /** Marca de cache-busting de la foto; null = sin foto. */
  avatarUpdatedAt: string | null;
  features?: AuthFeatures;
}

export interface AuthContextValue {
  user: AuthUser | null;
  loading: boolean;
  login: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  changePassword: (currentPassword: string, newPassword: string) => Promise<void>;
  acceptPrivacyPolicy: () => Promise<void>;
  /** Marca la versión del panel de novedades como vista y la persiste. */
  markWhatsNewSeen: (version: string) => Promise<void>;
  /** Refresca campos del usuario en memoria (p. ej. tras editar avatar/color). */
  updateUser: (partial: Partial<AuthUser>) => void;
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);
